/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';

import { Image, Col, Row } from 'react-bootstrap';

export interface IImageIconProps {
  imageIconURL?: string;
  height?: number;
  [key: string]: any;
}

export const ImageIcon = (props: IImageIconProps) => {
  return (
    <Row style={{ textAlign: 'center' }} className="mt-3 mb-2">
      <Col xs={12}>
        <Image src={props?.imageIconURL} height={props?.height} {...props} />
      </Col>
    </Row>
  );
};

ImageIcon.defaultProps = {
  imageIconURL: 'https://i.ibb.co/N7xLJF6/ImageIcon.png',
  height: 60,
};
